import React from "react";
import { Link } from "react-router-dom";
import { Phone, Info } from "lucide-react";
import { Hero } from "../components/Hero";
import { menuSections, menuExtra } from "../data/menu";

const HERO_DESKTOP = "/images/hero/HeroImageMenu-Desktop.webp";
const HERO_MOBILE = "/images/hero/HeroImageMenu-Mobile.webp";

export default function MenuPage() {
  return (
    <>
      <Hero
        testId="menu-hero"
        desktopImage={HERO_DESKTOP}
        mobileImage={HERO_MOBILE}
        alt="Il menù della Pizzeria Salviano a Livorno"
        eyebrow="Pizzeria Salviano · Livorno"
        title="Il nostro Menù"
        subtitle="Pizze classiche, speciali, focacce, torta livornese e specialità"
        actions={
          <>
            <a href="tel:+390586326286" className="ps-btn ps-btn-primary" data-testid="menu-hero-call">
              <Phone size={18} /> Chiama e ordina
            </a>
          </>
        }
      />

      <section className="py-14 sm:py-20" style={{ background: "var(--ps-cream)" }}>
        <div className="mx-auto max-w-4xl px-4 sm:px-6 text-center">
          <span className="ornament font-display text-sm sm:text-base uppercase tracking-[0.3em]">Il gusto della tradizione</span>
          <h2 className="section-title mt-5 text-3xl sm:text-4xl lg:text-5xl xl:text-6xl">
            Menù della Pizzeria Salviano
          </h2>
          <p className="mt-6 text-[var(--ps-ink-soft)] text-lg sm:text-xl leading-relaxed">
            Benvenuto nel menù della <strong>Pizzeria Salviano</strong>: pizze classiche, pizze speciali, focacce,
            calzoni, dolci e le tradizionali specialità della cucina livornese come la <strong>torta di ceci</strong>{" "}
            e il classico <strong>5 e 5</strong>. Impasti a lunga lievitazione e ingredienti freschi.
          </p>
        </div>
      </section>

      {/* Quick nav (NON sticky) */}
      <section className="pb-4" style={{ background: "var(--ps-cream)" }} data-testid="menu-quicknav">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 flex flex-wrap gap-2 justify-center">
          {menuSections.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              className="text-sm sm:text-base font-semibold uppercase tracking-[0.14em] px-4 py-2 rounded-full border border-[var(--ps-red)]/25 text-[var(--ps-red)] hover:bg-[var(--ps-red)] hover:text-white transition-colors"
              data-testid={`quicknav-${s.id}`}
            >
              {s.title}
            </a>
          ))}
        </div>
      </section>

      <section className="pb-16" style={{ background: "var(--ps-cream)" }}>
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          {menuSections.map((section) => (
            <div key={section.id} id={section.id} className="pt-16" data-testid={`menu-section-${section.id}`} style={{ scrollMarginTop: "120px" }}>
              <div className="text-center mb-6">
                <span className="ornament font-display text-xs uppercase tracking-[0.3em]">·</span>
                <h3 className="section-title mt-4 text-2xl sm:text-3xl lg:text-4xl">{section.title}</h3>
              </div>
              <div className="rounded-lg bg-white/60 p-5 sm:p-8 shadow-sm border border-[rgba(31,23,18,0.08)]">
                {section.items.map(([name, price]) => (
                  <div key={name} className="menu-row" data-testid="menu-item">
                    <span className="name">{name}</span>
                    <span className="price">€ {price}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div
            className="mt-12 rounded-lg p-6 sm:p-7 flex items-start gap-4"
            style={{ background: "rgba(139,30,30,0.06)", border: "1px solid rgba(139,30,30,0.2)" }}
            data-testid="menu-extra"
          >
            <Info size={24} className="text-[var(--ps-red)] mt-0.5 shrink-0" />
            <div>
              <div className="font-display uppercase tracking-[0.14em] text-[var(--ps-red)] text-base">Extra</div>
              <p className="mt-1 text-[var(--ps-ink-soft)] text-base sm:text-lg">{menuExtra}</p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link to="/contatti" className="ps-btn ps-btn-primary" data-testid="menu-cta-contact">
              Contattaci per ordinare
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
